import {Injectable, Injector} from '@angular/core';
import {MatomoInitializerService, MatomoTracker} from 'ngx-matomo-client';
import {Event, NavigationEnd, Router, RouterEvent} from '@angular/router';
import {filter} from 'rxjs/operators';


@Injectable()
export class MatomoProvider {
  constructor(
    private injector: Injector,
    private matomoTracker: MatomoTracker,
    private matomoInitializer: MatomoInitializerService
  ) {}

  init(): void {
    const allowEnviroments = [
      'https://beta.cloud.lancom.de',
      'https://cloud.lancom.de',
      'https://dev.cloud.lancom.de'
    ];
    const currentEnviroment = window.location.origin;
    if (allowEnviroments.includes(currentEnviroment)) {
      this.matomoInitializer.initializeTracker({
        siteId: '1',
        trackerUrl: currentEnviroment + '/analytics',
        trackerUrlSuffix: '/piwik.php',
        scriptUrl: currentEnviroment  + '/analytics/piwik.js'
      });
      this.anonymizedMatomoUrl(window.location.pathname);
      this.trackPageViewOnNavigation();
      this.matomoTracker.disableCookies();
    }
  }

  trackEvent(category: string, action: string, name?: string, value?: number) {
    this.matomoTracker.trackEvent(category, action, name, value);
  }

  private anonymizedMatomoUrl(url): void {
    const regexUUID = /[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}/g;
    const regexSHA256 = /[A-Fa-f0-9]{64}/g;
    const anonymizedPath = url.replace(regexSHA256, '*').replace(regexUUID, '*');
    this.matomoTracker.setReferrerUrl(anonymizedPath);
    this.matomoTracker.setCustomUrl(anonymizedPath);
  }

  private trackPageViewOnNavigation(): void {
    const router = this.injector.get(Router);
    router.events
      .pipe(
        filter(
          (event: Event | RouterEvent): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event) => {
        this.anonymizedMatomoUrl(event.urlAfterRedirects);
        this.matomoTracker.trackPageView();
      });
  }
}

